var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDown = function SvgArrowDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow-down_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow-down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13q-.286 0-.538-.095a1.25 1.25 0 0 1-.466-.325L.395 5.557Q0 5.137 0 4.49q0-.65.395-1.07T1.399 3q.61 0 1.005.42L8 9.374l5.596-5.954Q13.991 3 14.601 3t1.004.42T16 4.489q0 .648-.395 1.068l-6.6 7.023q-.216.23-.467.325A1.5 1.5 0 0 1 8 13"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export default ForwardRef;